import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	titleText: {
		maxWidth: "950px",
		fontSize: "32px",
		lineHeight: "38px",
		color: colors.gray[800]
	},
	copyButton: {
		width: "fit-content",
		fontWeight: 500,
		color: colors.gray[500],
		"&:hover": {
			textDecoration: "underline",
			background: "transparent",
			color: colors.blue[700]
		}
	}
}))

export default useStyles
